<div
  [forceVisible]="forceVisible"
  [viewportOptions]="{
    verticalTolerance: 500,
    horizontalTolerance: 10,
    shouldCheckHorizontal: false
  }"
  (visibilityChange)="onVisibilityChange($event)"
  astrobinScrollVisibility
>
  <div *ngIf="comments$ | async as comments; else loadingTpl" class="nested-comments card">
    <div class="card-header">
      {{ title }}

      <div class="actions">
        <astrobin-refresh-button (click)="refresh()"></astrobin-refresh-button>
        <button
          *ngIf="showCloseButton"
          (click)="close.emit()"
          class="btn btn-link btn-no-block btn-close ms-2"
        ></button>
      </div>
    </div>

    <div class="card-body">
      <p *ngIf="!!info" [class]="infoClass">
        <fa-icon class="me-2" icon="info-circle"></fa-icon>
        <span [innerHTML]="info"></span>
      </p>

      <ng-container
        *ngIf="showTopLevelForm && topLevelFormPlacement === 'TOP'"
        [ngTemplateOutlet]="topLevelFormTpl"
      ></ng-container>

      <ng-container
        *ngIf="showTopLevelButton && topLevelFormPlacement === 'TOP' && !showTopLevelForm"
        [ngTemplateOutlet]="addCommentButtonTpl"
      ></ng-container>

      <ng-container *ngIf="!loadingComments; else loadingContentTpl">
        <ng-container
          *ngFor="let comment of comments; trackBy: commentTrackByFn"
          [ngTemplateOutlet]="commentsTpl"
          [ngTemplateOutletContext]="{ comment }"
        ></ng-container>
        <ng-container *ngIf="comments.length === 0" [ngTemplateOutlet]="noCommentsTpl"></ng-container>
      </ng-container>

      <ng-container
        *ngIf="showTopLevelForm && topLevelFormPlacement === 'BOTTOM'"
        [ngTemplateOutlet]="topLevelFormTpl"
      ></ng-container>

      <ng-container
        *ngIf="showTopLevelButton && topLevelFormPlacement === 'BOTTOM' && !showTopLevelForm"
        [ngTemplateOutlet]="addCommentButtonTpl"
      ></ng-container>
    </div>
    <!-- card-body -->
  </div>
  <!-- card -->
</div>

<ng-template #loadingTpl>
  <div class="nested-comments card">
    <div class="card-header">
      {{ title }}
      <div class="actions">
        <astrobin-refresh-button (click)="refresh()"></astrobin-refresh-button>
        <button
          *ngIf="showCloseButton"
          (click)="close.emit()"
          class="btn btn-link btn-no-block btn-close ms-2"
        ></button>
      </div>
    </div>
    <div class="card-body">
      <div class="comments-loading">
        <astrobin-loading-indicator></astrobin-loading-indicator>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loadingContentTpl>
  <div class="comments-loading">
    <astrobin-loading-indicator></astrobin-loading-indicator>
  </div>
</ng-template>

<ng-template #topLevelFormTpl>
  <div class="top-level-form">
    <astrobin-read-only-mode *ngIf="(readOnlyMode$ | async) === true; else formTemplate"></astrobin-read-only-mode>

    <ng-template #formTemplate>
      <form [formGroup]="form">
        <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
      </form>

      <div class="form-actions">
        <button
          *ngIf="autoStartTopLevelStrategy === null"
          [class.loading]="loadingService.loading$ | async"
          (click)="cancelTopLevelComment()"
          class="btn btn-sm btn-outline-secondary me-sm-2"
        >
          {{ "Cancel" | translate }}
        </button>

        <button
          [class.loading]="loadingService.loading$ | async"
          [disabled]="!form.valid"
          (click)="submitTopLevelComment()"
          class="btn btn-primary btn-sm"
        >
          {{ "Submit" | translate }}
        </button>

        <button *ngIf="showCloseButton" (click)="close.emit()" class="btn btn-secondary btn-sm ms-md-1">
          {{ "Close" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #addCommentButtonTpl>
  <button (click)="onAddCommentClicked($event)" class="btn btn-outline-primary add-comment">
    <fa-icon icon="comment"></fa-icon>
    {{ addCommentLabel }}
  </button>
</ng-template>

<ng-template #commentsTpl let-comment="comment">
  <astrobin-nested-comment
    [allowModeration]="allowModeration"
    [allowSelfReply]="allowSelfReply"
    [category]="category"
    [comment]="comment"
    [commentContentType]="commentContentType"
    [highlighted]="comment.id === highlightId"
    [restrictReplyToUserId]="restrictReplyToUserId"
    [showReplyButton]="showReplyButton"
    [useOffcanvasOnTouchDevices]="useOffcanvasOnTouchDevices"
    (formDirtyChange)="onNestedCommentFormDirtyChange($event)"
  ></astrobin-nested-comment>
</ng-template>

<ng-template #noCommentsTpl>
  <p class="no-comments" data-test="no-comments">
    {{ noCommentsLabel }}
  </p>
</ng-template>

<ng-template #topLevelCommentOffcanvasTpl let-close="close" let-dismiss="dismiss">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">{{ title }}</h5>
    <button
      (click)="confirmCloseOffcanvas(dismiss)"
      class="btn-close text-reset"
      aria-label="Close"
      type="button"
    ></button>
  </div>
  <div class="offcanvas-body offcanvas-tiptap-compact">
    <astrobin-read-only-mode
      *ngIf="(readOnlyMode$ | async) === true; else offcanvasFormTemplate"
    ></astrobin-read-only-mode>

    <ng-template #offcanvasFormTemplate>
      <form [formGroup]="form">
        <formly-form [fields]="offcanvasFields" [form]="form" [model]="model"></formly-form>
      </form>

      <div class="form-actions mt-3">
        <button
          [class.loading]="_isSubmittingTopLevelComment"
          [disabled]="!form.valid || _isSubmittingTopLevelComment"
          (click)="submitTopLevelCommentOffcanvas()"
          class="btn btn-primary btn-sm"
        >
          {{ "Submit" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>
